const polishProductPage = () => {
  const root = document.querySelector("#MainContent[data-template^='product']");
  if (!root) return;

  const titleBlock = root.querySelector('.text-block--text_xrnftG');
  const oldTitle = titleBlock?.querySelector('h3');
  if (oldTitle && !titleBlock.querySelector('.district-product-title')) {
    const title = document.createElement('h1');
    title.className = 'district-product-title';
    title.innerHTML = oldTitle.innerHTML;
    for (const attr of oldTitle.attributes) title.setAttribute(attr.name, attr.value);
    title.classList.add('district-product-title');
    oldTitle.replaceWith(title);
  }

  const descriptionRow = [...root.querySelectorAll('details')].find((details) => {
    const summary = details.querySelector('summary');
    return summary?.textContent.trim().startsWith('Descripción');
  });

  if (descriptionRow) {
    descriptionRow.removeAttribute('open');
    const accordion = descriptionRow.closest('accordion-custom');
    accordion?.removeAttribute('open-by-default-on-desktop');
    accordion?.removeAttribute('open-by-default-on-mobile');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', polishProductPage, { once: true });
} else {
  polishProductPage();
}

document.addEventListener('shopify:section:load', polishProductPage);
